import {
    Avatar,
    Button,
    Container,
    Icon,
    Paper,
    Stack,
    TextField,
} from "@mui/material";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ErrorDetailContainer } from "../../api/config";
import { AccountService, UserDto } from "../../api/identity";
import { PageHeader, Spinner } from "../../components/exports";
import ErrorParser from "../../components/shared/ErrorParser";

// updated
export default function Profile() {
    const navigate = useNavigate();

    const [user, setUser] = useState<UserDto | null>(null);
    const [isUploadingAvatar, setIsUploadingAvatar] = useState(false);
    const [requestInProgress, setRequestInProgress] = useState<boolean>(false);
    const [error, setError] = useState<ErrorDetailContainer | null>(null);

    const fileInputRef = useRef(null);

    useEffect(() => {
        AccountService.getProfile().then((r) => {
            setUser(r);
        });
    }, []);

    const handleDisplayNameChange = (
        elem: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const userToUpdate = { ...user, displayName: elem.target.value };
        setUser(userToUpdate);
    };

    const openSelectAvatarImageFileInput = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (ev: ChangeEvent<HTMLInputElement>) => {
        const file = ev.target.files[0];
        uploadImage(file);
    };

    const uploadImage = (file: File) => {
        setIsUploadingAvatar(true);
        AccountService.uploadAvatarImage({
            formFile: file,
        }).then((r) => {
            const userToUpdate = { ...user, avatarUrl: r };
            setUser(userToUpdate);
            setIsUploadingAvatar(false);
        });
    };

    const update = () => {
        setRequestInProgress(true);
        AccountService.updateProfile({
            avatarUrl: user.avatarUrl,
            displayName: user.displayName,
            mobileNumber: user.mobileNumber,
        })
            .then((r) => {})
            .catch((e) => {
                setError(e);
            })
            .finally(() => {
                setRequestInProgress(false);
            });
    };

    const openEditPasswordDialog = () => {
        navigate("/assign/password");
    };

    if (user === null) {
        return <Spinner />;
    }

    return (
        <Container maxWidth="xs">
            <PageHeader title="ویرایش پروفایل" />

            <Paper sx={{ p: 2 }}>
                <input
                    ref={fileInputRef}
                    type="file"
                    hidden
                    onChange={handleFileChange}
                />

                <Stack spacing={2} alignItems="center">
                    {isUploadingAvatar ? (
                        <Spinner />
                    ) : (
                        <Avatar
                            onClick={openSelectAvatarImageFileInput}
                            src={user.avatarUrl}
                            sx={{ width: 100, height: 100, cursor: "pointer" }}
                        />
                    )}

                    <TextField
                        fullWidth
                        onChange={handleDisplayNameChange}
                        value={user.displayName}
                        label="نام نمایشی"
                        variant="outlined"
                    />

                    <TextField
                        disabled
                        fullWidth
                        value={user.mobileNumber}
                        label="شماره موبایل"
                        variant="outlined"
                    />

                    <ErrorParser error={error} />

                    <Button
                        disabled={requestInProgress}
                        fullWidth
                        onClick={update}
                        variant="contained"
                    >
                        به روز رسانی
                    </Button>

                    <Button
                        onClick={openEditPasswordDialog}
                        fullWidth
                        color="secondary"
                        variant="outlined"
                        startIcon={<Icon>edit</Icon>}
                    >
                        تخصیص / ویرایش رمز عبور
                    </Button>
                </Stack>
            </Paper>
        </Container>
    );
}
